import moment from 'moment'
import { usesFirebaseSession } from '@/utils/session-config'
import getDefaultState from './defaultState'

export default {
  setSession(state, value) {
    state.session = value
  },
  setSessionActivity(state, { at, inactive }) {
    state.lastActivity = at / 1000
    state.isInactive = inactive
  },
  resetState(state) {
    Object.assign(state, getDefaultState())
  },
  setTokens(state, { accessToken, refreshToken, firebaseToken }) {
    if (
      usesFirebaseSession() &&
      (accessToken || refreshToken || firebaseToken)
    ) {
      throw new Error('Firebase sessions cannot store Django credentials')
    }
    state.accessToken = accessToken
    state.refreshToken = refreshToken

    if (accessToken) {
      localStorage.setItem('blytzpay_access_token', accessToken)
    } else if (accessToken === null) {
      localStorage.removeItem('blytzpay_access_token')
    }

    if (refreshToken) {
      localStorage.setItem('blytzpay_refresh_token', refreshToken)
    } else if (refreshToken == null) {
      localStorage.removeItem('blytzpay_refresh_token')
    }

    // Only touch the firebase token when the caller provides the key, so
    // partial updates (e.g. a refresh that omits it) don't clear it.
    if (firebaseToken !== undefined) {
      state.firebaseToken = firebaseToken

      if (firebaseToken) {
        localStorage.setItem('blytzpay_firebase_token', firebaseToken)
      } else {
        localStorage.removeItem('blytzpay_firebase_token')
      }
    }
  },
  setLastActivity(state) {
    if (usesFirebaseSession()) return
    /*
     Sets the last activity as a utc unix timestamp
     This method should mostly be called from an axios interceptor
    */
    state.lastActivity = moment().utc().unix()
  },
  setIsInactive(state, isInactive) {
    state.isInactive = isInactive
  },
  setProfile(state, profile) {
    state.profile = profile
  },
  setNotificationMarks(state, marks) {
    state.notificationMarks = marks
  },
  setHeartbeat(state, heartbeat) {
    state.heartbeat = heartbeat
  }
}
